
/* eslint-disable prefer-const */

export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: { type: String },
    modelValue: { default: '' },
    trueValue: { default: true },
    falseValue: { default: false },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value)
      }
      return this.modelValue === this.trueValue
    },
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      if (Array.isArray(this.modelValue)) {
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    },
  },
}
